import { useState } from 'react';
import { useQuery } from 'react-query';
import { config } from '../config/config';
import { getUsersCLients, getUsersClientsPlatforms, getUsersClientsProjects, getUsersDataClient, getUsersDataClientPlatforms, getUsersDataClientProjects, getUsersPlatforms, getUsersProjects, getUsersRoles, postClients, postPlatforms, postProjects } from '../services/API/usersAPI';

const initialDataUser = {
  user_name: "",
  user_password: "",
  clients: "",
  proyects: "",
  platforms: "",
}
export const useUsers = () => {
  const dataUser = JSON.parse(sessionStorage.getItem("userData"));
  const Token = dataUser?.token;
  const [body, setBody] = useState(initialDataUser);
  const [loadPage, setLoadPage] = useState(false);
  var validateClients = [];

  //Fetching

  const [optionClients, setOptionsClients] = useState([]);
  const [TableRoles, setOptionsRoles] = useState([]);
  const [optionProjects, setProjects] = useState([]);
  const [optionPlatforms, setPlatforms] = useState([]);
  const [optionDataClient, setOptionDataClient] = useState("");
  const [idDataClient, setIdDataClient] = useState(0)
  const [client, setDataClient] = useState('')
  const [queryEnabled, setQueryEnabled] = useState([true, true, false, false, false, false, false, false, false]);

  const { isLoading: loadOptionClient, isError: ErrorOptionClient } = useQuery({
    queryKey: ['dataOptionsClient', Token],
    queryFn: () => getUsersCLients(Token),
    enabled: queryEnabled[0],
    retry: 2,
    onSuccess: (dataOptionsClient) => {
      const newArray = [...queryEnabled];
      newArray[0] = false;
      setQueryEnabled(newArray);
      const defaultOptionsClient = dataOptionsClient.map((item) => {
        return item;
      });
      setOptionsClients(defaultOptionsClient);
    },
    onError: () => {
      const newArray = [...queryEnabled];
      newArray[0] = false;
      setQueryEnabled(newArray);
    }
  })

  const { isLoading: loadOptionRole, isError: ErrorOptionRoles } = useQuery({
    queryKey: ['dataOptionsRoles', Token],
    queryFn: () => getUsersRoles(Token),
    enabled: queryEnabled[1],
    retry: 2,
    onSuccess: (dataOptionsRoles) => {
      const newArray = [...queryEnabled];
      newArray[1] = false;
      setQueryEnabled(newArray);
      const defaultOptionsRoles = dataOptionsRoles.map((item) => {
        return item.permissions;
      });
      setOptionsRoles(defaultOptionsRoles);
    },
    onError: () => {
      const newArray = [...queryEnabled];
      newArray[1] = false;
      setQueryEnabled(newArray);
    }
  })


  const { isError: ErrorDataClient } = useQuery({
    queryKey: ['dataUsersClientsProjects', Token, optionDataClient],
    queryFn: () => getUsersClientsProjects(Token, optionDataClient),
    enabled: !!optionDataClient && queryEnabled[2],
    retry: 2,
    onSuccess: (dataUsersClientsProjects) => {
      const newArray = [...queryEnabled];
      newArray[2] = false;
      setQueryEnabled(newArray);
      setProjects(dataUsersClientsProjects);
    },
    onError: () => {
      const newArray = [...queryEnabled];
      newArray[2] = false;
      setQueryEnabled(newArray);
    }
  });

  const { isError: ErrorClientsProjects, refetch: refetchClientsProjects } = useQuery({
    queryKey: ['dataUsersClientsProjects', Token],
    queryFn: () => getUsersClientsProjects(Token, idDataClient),
    enabled: false,
    retry: 2,
    onSuccess: (dataUsersClientsProjects) => {
      const newArray = [...queryEnabled];
      newArray[3] = false;
      setQueryEnabled(newArray);
      const defaultDataOptionsProyects = dataUsersClientsProjects.map((item) => {
        return item.proyect;
      });
      setProjects([...new Set(defaultDataOptionsProyects)]);
      //setProjects(defaultDataOptionsProyects);
    },
    onError: () => {
      const newArray = [...queryEnabled];
      newArray[3] = false;
      setQueryEnabled(newArray);
    }
  })

  const { data: defaultDataOptionsProyects, isError: ErrorClientsPlatforms, refetch: refetchClientsPlatforms } = useQuery({
    queryKey: ['dataUsersClientsPlatforms', Token],
    queryFn: () => getUsersClientsPlatforms(Token, idDataClient),
    enabled: false,
    retry: 2,
    onSuccess: (dataUsersClientsPlatforms) => {
      const newArray = [...queryEnabled];
      newArray[4] = false;
      setQueryEnabled(newArray);
      const defaultDataOptionsPlatforms = dataUsersClientsPlatforms.map((item) => {
        return item.platform;
      });
      setPlatforms([...new Set(defaultDataOptionsPlatforms)]);
      //setPlatforms(defaultDataOptionsPlatforms);
    },
    onError: () => {
      const newArray = [...queryEnabled];
      newArray[4] = false;
      setQueryEnabled(newArray);
    }
  })

  const { data: defaultDataOptionsPlatforms, isError: ErrorProjects, refetch: refetchProjects } = useQuery({
    queryKey: ['dataUsersProjects', Token],
    queryFn: () => getUsersProjects(Token),
    enabled: false,
    retry: 2,
    onSuccess: (dataUsersProjects) => {
      const newArray = [...queryEnabled];
      newArray[5] = false;
      setQueryEnabled(newArray);
      const defaultDataOptionsProyects = dataUsersProjects.map((item) => {
        return item.proyect;
      });
      const OptionsProyects = defaultDataOptionsProyects.filter(
        (valor, indice, self) => {
          return self.indexOf(valor) === indice;
        }
      );
      setProjects(OptionsProyects);
    },
    onError: () => {
      const newArray = [...queryEnabled];
      newArray[5] = false;
      setQueryEnabled(newArray);
    }
  })

  const { isError: ErrorPlatforms, refetch: refetchPlatforms } = useQuery({
    queryKey: ['dataUsersPlatforms', Token],
    queryFn: () => getUsersPlatforms(Token),
    enabled: false,
    retry: 2,
    onSuccess: (dataUsersPlatforms) => {
      const newArray = [...queryEnabled];
      newArray[6] = false;
      setQueryEnabled(newArray);
      const defaultDataOptionsPlatforms = dataUsersPlatforms.map((item) => {
        return item.platform;
      });
      const OptionsPlatforms = defaultDataOptionsPlatforms.filter(
        (valor, indice, self) => {
          return self.indexOf(valor) === indice;
        }
      );
      setPlatforms(OptionsPlatforms);
    },
    onError: () => {
      const newArray = [...queryEnabled];
      newArray[6] = false;
      setQueryEnabled(newArray);
    }
  })

  const { isError: ErrorDataClientsProjects, refetch: refetchDataClientsProjects } = useQuery({
    queryKey: ['dataUsersDataClientsProjects', Token],
    queryFn: () => getUsersDataClientProjects(Token, idDataClient),
    enabled: false,
    retry: 2,
    onSuccess: (dataClientsProjects) => {
      const newArray = [...queryEnabled];
      newArray[7] = false;
      setQueryEnabled(newArray);
      const defaultDataOptionsProyects = dataClientsProjects.map((item) => {
        return item.proyect;
      });
      setProjects([...new Set(defaultDataOptionsProyects)]);
    },
    onError: () => {
      const newArray = [...queryEnabled];
      newArray[7] = false;
      setQueryEnabled(newArray);
    }
  })

  const { isError: ErrorDataClientsPlatforms, refetch: refetchDataClientsPlatforms } = useQuery({
    queryKey: ['dataUsersDataClientsPlatforms', Token],
    queryFn: () => getUsersDataClientPlatforms(Token, idDataClient),
    enabled: false,
    retry: 2,
    onSuccess: (dataClientsPlatrforms) => {
      const newArray = [...queryEnabled];
      newArray[8] = false;
      setQueryEnabled(newArray);
      const defaultDataOptionsPlatforms = dataClientsPlatrforms.map((item) => {
        return item.platform;
      });
      setPlatforms([...new Set(defaultDataOptionsPlatforms)]);
    },
    onError: () => {
      const newArray = [...queryEnabled];
      newArray[8] = false;
      setQueryEnabled(newArray);
    }
  })
  

  const { data: listClient, isLoading: loadClients, isError: ErrorClients, refetch: refectClients } = useQuery(
    ['listClient', Token, client],
    () => getUsersDataClient(Token, client),
    {
      enabled: false,
      retry: 2,
      onError: () => {
      },
      onSuccess: (data) => {
        
        const newQueryEnabled = [...queryEnabled];
        newQueryEnabled[2] = true;
        setOptionDataClient(data.idclient)
        setIdDataClient(data.idclient)
        setTimeout(() => {
          setQueryEnabled(newQueryEnabled);
          refetchClientsPlatforms()
        }, 500);
      }
    }
  );
  //Funciones

  function validatePassword(password) {
    const lengthRegex = /.{8,}/;
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const digitRegex = /\d/;
    const specialCharacterRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;

    return (
      lengthRegex.test(password) &&
      uppercaseRegex.test(password) &&
      lowercaseRegex.test(password) &&
      digitRegex.test(password) &&
      specialCharacterRegex.test(password)
    );
  }

  async function handleCheckDuplicates() {
    validateClients = body.clients;
    if (!Array.isArray(validateClients)) {
      validateClients = [validateClients];
    }

    const dataClients = await getUsersCLients(Token);
    const ArrayDataClients = dataClients.map((item) => {
      return item.client;
    });
    const uniqueArrayClients = [...new Set(ArrayDataClients)];
    const newClient = validateClients.filter(
      (element) => !ArrayDataClients.includes(element)
    );
    const oldClient = validateClients.filter(
      (element) => uniqueArrayClients.indexOf(element) !== -1
    );

    const validateProyects = body.proyects;
    const uniqueArrayvalidateProyects = [...new Set(validateProyects)];
    const dataProyects = await getUsersProjects(Token)
    const ArrayDataProyects = dataProyects.map((item) => {
      return item.proyect;
    });
    const uniqueArrayProyects = [...new Set(ArrayDataProyects)];
    const newProyect = uniqueArrayvalidateProyects.filter(
      (element) => !uniqueArrayProyects.includes(element)
    );
    const oldProyect = uniqueArrayvalidateProyects.filter(
      (element) => uniqueArrayProyects.indexOf(element) !== -1
    );

    const validatePlatforms = body.platforms;
    const uniqueArrayvalidatePlatforms = [...new Set(validatePlatforms)];
    const dataPlatforms = await getUsersPlatforms(Token)
    const ArrayDataPlatforms = dataPlatforms.map((item) => {
      return item.platform;
    });
    const uniqueArrayPlatforms = [...new Set(ArrayDataPlatforms)];
    const newPlatform = uniqueArrayvalidatePlatforms.filter(
      (element) => !uniqueArrayPlatforms.includes(element)
    );
    const oldPlatform = uniqueArrayvalidatePlatforms.filter(
      (element) => uniqueArrayPlatforms.indexOf(element) !== -1
    );

    //Si se creea un nuevo cliente asocia los datos de ese cliente con los proyectos y plataformas que se seleccionen así estas sean nuevas
    if (newClient.length > 0) {
      newClient.forEach(async (elemento) => {
        try {
          const data = await postClients({ client: elemento }, Token);
          validateProyects.forEach(async (elemento) => {
            try {
              const data2 = await postProjects({
                proyect: elemento,
                clientId: data.idclient,
              }, Token);
            } catch (error) {
              console.error("Error al realizar la solicitud:", error);
            }
          });
          validatePlatforms.forEach(async (elemento) => {
            try {
              const data3 = await postPlatforms({
                platform: elemento,
                clientId: data.idclient,
              }, Token);
            } catch (error) {
              console.error("Error al realizar la solicitud:", error);
            }
          });
        } catch (error) {
          console.error("Error al realizar la solicitud:", error);
        }
      });
    }
    //Si se crea un nuevo proyecto pero el client ya esta existente
    if (newProyect.length > 0 && newClient.length === 0) {
      //Se encarga de asociar los proyectos nuevos al cliente cuando no haya clientes nuevos
      newProyect.forEach(async (elemento) => {
        validateClients.forEach(async (elemento2) => {
          try {
            const idClient = await getUsersDataClient(Token, elemento2);
            const data = await postProjects({
              proyect: elemento,
              clientId: idClient.idclient,
            }, Token);
          } catch (error) {
            console.error("Error al realizar la solicitud:", error);
          }
        });
      });
      //Se encarga de asociar las plataformas nuevas al cliente cuando no haya un cliente nuevo
      newPlatform.forEach(async (elemento) => {
        validateClients.forEach(async (elemento2) => {
          try {
            const idClient = await getUsersDataClient(Token, elemento2);
            const data = await postPlatforms({
              platform: elemento,
              clientId: idClient.idclient,
            }, Token);
          } catch (error) {
            console.error("Error al realizar la solicitud:", error);
          }
        });
      });
    }
    //Si se crea una nueva plataforma pero el client ya esta existente y el proyecto tambien
    if (
      newPlatform.length > 0 &&
      newClient.length === 0 &&
      newProyect.length === 0
    ) {
      //Se encarga de asociar las plataformas nuevas al cliente cuando no haya proyectos ni clientes nuevos
      newPlatform.forEach(async (elemento) => {
        validateClients.forEach(async (elemento2) => {
          try {
            const idClient = await getUsersDataClient(Token, elemento2);
            const data = await postPlatforms({
              platform: elemento,
              clientId: idClient.idclient,
            }, Token);
          } catch (error) {
            console.error("Error al realizar la solicitud:", error);
          }
        });
      });
    }
    //Validar que los proyectos y las plataformas viejas ya esten asociados al cliente viejo
    oldProyect.forEach(async (elemento) => {
      oldClient.forEach(async (elemento2) => {
        try {
          const idClient = await getUsersDataClient(Token, elemento2);
          const validateProyect = await getUsersClientsProjects(Token, idClient.idclient);
          const ArrayValidateProyect = validateProyect.map((item) => {
            return item.proyect;
          });
          if (ArrayValidateProyect.includes(elemento) === false) {
            const data = await postProjects({
              proyect: elemento,
              clientId: idClient.idclient,
            }, Token);
          }
        } catch (error) {
          console.error("Error al realizar la solicitud:", error);
        }
      });
    });
    //Se encarga de asociar los plataformas existentes al cliente cuando no haya clientes ni proyectos nuevos
    oldPlatform.forEach(async (elemento) => {
      oldClient.forEach(async (elemento2) => {
        try {
          const idClient = await getUsersDataClient(Token, elemento2);
          const validatePlatform = await getUsersClientsPlatforms(Token, idClient.idclient);
          const ArrayValidatePlatform = validatePlatform.map((item) => {
            return item.platform;
          });
          if (ArrayValidatePlatform.includes(elemento) === false) {
            const data = await postPlatforms({
              platform: elemento,
              clientId: idClient.idclient,
            }, Token);
          }
        } catch (error) {
          console.error("Error al realizar la solicitud:", error);
        }
      });
    });
  }

  return {
    handleCheckDuplicates,
    validatePassword,
    setBody,
    setLoadPage,
    body,
    loadPage,
    loadOptionClient,
    ErrorOptionClient,
    loadOptionRole,
    ErrorOptionRoles,
    optionClients,
    setOptionsClients,
    setOptionsRoles,
    TableRoles,
    ErrorDataClient,
    ErrorClientsProjects,
    refetchClientsProjects,
    ErrorClientsPlatforms,
    refetchClientsPlatforms,
    setOptionDataClient,
    idDataClient,
    optionProjects,
    optionPlatforms,
    refetchPlatforms,
    ErrorPlatforms,
    refetchProjects,
    ErrorProjects,
    queryEnabled,
    Token,
    setProjects,
    setPlatforms,
    defaultDataOptionsProyects,
    defaultDataOptionsPlatforms,
    setIdDataClient,
    refetchDataClientsPlatforms,
    refetchDataClientsProjects,
    setQueryEnabled,
    setDataClient,
    refectClients
  }
}
